import { render, staticRenderFns } from "./hintCard.vue?vue&type=template&id=5654443c&scoped=true&"
import script from "./hintCard.vue?vue&type=script&lang=js&"
export * from "./hintCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5654443c",
  null
  
)

export default component.exports